import { CHANNELS, PARTY } from '../data/catalog';
import { SERIES_HEX } from '../theme/tokens';

/**
 * Static channel metadata — names, colours, and what the "party" column is called.
 *
 * Kept separate from `utils/analytics` so a component that only needs a channel's
 * colour doesn't pull the generated sample ledger into the bundle with it.
 */
export const CH = CHANNELS;
export const CHMAP = Object.fromEntries(CH.map((c) => [c.id, c]));
export const CHCOLOR = Object.fromEntries(CH.map((c, i) => [c.id, SERIES_HEX[i]]));

export { PARTY };
